import { render, staticRenderFns } from "./Comandera.vue?vue&type=template&id=2657636a"
import script from "./Comandera.vue?vue&type=script&lang=js"
export * from "./Comandera.vue?vue&type=script&lang=js"
import style0 from "./Comandera.vue?vue&type=style&index=0&id=2657636a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports